import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  
  useEffect(() => {
    const params = {}; if (filter && filter !== "all") params.status = filter;
    api.get("/admin/leads", { params }).then(r => setItems(r.data || [])).catch(() => {});
  }, [filter]);
  
  const load = () => {
    const params = {}; if (filter && filter !== "all") params.status = filter;
    api.get("/admin/leads", { params }).then(r => setItems(r.data || [])).catch(() => {});
  };

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/leads/${id}`, { status }); toast.success("Status atualizado"); load(); }
    catch { toast.error("Erro"); }
  };

  return (
    <AdminLayout title="Inscrições">
      <Card className="rounded-xl"><CardContent className="p-4 flex gap-3 items-end">
        <div><p className="text-xs text-muted-foreground mb-1">Status</p>
          <Select value={filter} onValueChange={setFilter}>
            <SelectTrigger className="w-[200px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              <SelectItem value="novo">Novo</SelectItem>
              <SelectItem value="contatado">Contatado</SelectItem>
              <SelectItem value="convertido">Convertido</SelectItem>
              <SelectItem value="descartado">Descartado</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent></Card>
      <Card className="rounded-xl mt-4"><CardContent className="p-0 overflow-x-auto">
        <Table><TableHeader><TableRow>
          <TableHead>Nome</TableHead><TableHead>Curso</TableHead><TableHead>Email</TableHead><TableHead>Telefone</TableHead><TableHead>Local</TableHead><TableHead>Pessoas</TableHead><TableHead>Status</TableHead>
        </TableRow></TableHeader>
          <TableBody>
            {items.map(l => (
              <TableRow key={l.id}>
                <TableCell><p className="font-medium">{l.full_name}</p><p className="text-xs text-muted-foreground">{l.orgao}</p></TableCell>
                <TableCell><p className="text-sm">{l.course?.title || "—"}</p><p className="text-xs text-muted-foreground">{l.course?.cidade}/{l.course?.estado}</p></TableCell>
                <TableCell className="text-xs">{l.email}</TableCell>
                <TableCell className="text-xs">{l.phone}</TableCell>
                <TableCell className="text-xs">{l.cidade}/{l.estado}</TableCell>
                <TableCell>{l.participants}</TableCell>
                <TableCell>
                  <Select value={l.status} onValueChange={(v) => setStatus(l.id, v)}>
                    <SelectTrigger className="w-[150px]" data-testid={`lead-status-${l.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="novo">Novo</SelectItem>
                      <SelectItem value="contatado">Contatado</SelectItem>
                      <SelectItem value="convertido">Convertido</SelectItem>
                      <SelectItem value="descartado">Descartado</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={7} className="py-10 text-center text-sm text-muted-foreground">Nenhuma inscrição</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </AdminLayout>
  );
}
